import { GlobalStore } from "types/store"

export const getPreventionHandoffLink = ({ preventionHandoff }: GlobalStore) => preventionHandoff?.link
export const getPreventionHandoffStatus = ({ preventionHandoff }: GlobalStore) => preventionHandoff?.status
export const isPreventionHandoffLoading = ({ preventionHandoff }: GlobalStore) =>
  Boolean(preventionHandoff?.loading)
